import {
  Component,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  OnInit,
} from '@angular/core';
import { SiteAlertService } from '@accounts/services/site-alert.service';
import {
  NotificationDetails,
  NotificationMessage,
} from '@accounts/accounts-alerts/accounts-alerts.interface';
import { takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { Logger } from '@utils/logger';
import { Page } from '@bloomreach/spa-sdk';

const logger = Logger.getLogger('SiteAlertComponent');
@Component({
  selector: 'ft-site-alert',
  templateUrl: './site-alert.component.html',
})
export class SiteAlertComponent implements OnDestroy, OnInit {
  /**
   * The Bloomreach page
   */
  @Input() page!: Page;

  /**
   * The Notification details
   */
  siteAlerts$: Observable<NotificationMessage[]>;
  notificationDetails: NotificationDetails;

  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private cd: ChangeDetectorRef,
    public siteAlertService: SiteAlertService
  ) {}

  ngOnInit(): void {
    this.setNotificationContext();
    this.siteAlerts$ = this.siteAlertService.getSiteAlerts$();
    // detect changes after observable emits new value
    this.siteAlerts$.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.cd.detectChanges();
    });
  }

  /**
   * Set site name and notification page type
   */
  private setNotificationContext(): void {
    // Get site query scope
    const scope = this.page?.getComponent('notifications')?.getModels()?.scope;
    const siteName = scope?.split('/')?.pop();
    this.siteAlertService.setSiteName(siteName);

    // Get Notification Page type from page data
    const pageData = this.page?.getComponent()?.getModels()?.pageData;
    let notificationPageType = pageData?.notificationPageType;
    // workaround for product pages - which are not xpages
    if (!notificationPageType && pageData?.pageType === 'product') {
      notificationPageType = 'product';
    }
    this.siteAlertService.setNotificationPageType(notificationPageType);
  }

  closeSiteAlert(notificationDetails: NotificationDetails): void {
    this.siteAlertService.removeSiteAlert(notificationDetails);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
